var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"w-logo",style:(_vm.rootStyle),attrs:{"nuxt":"","href":"/"}},[_c('img',{attrs:{"src":_vm.logoPath,"alt":_vm.$t('title'),"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }